import * as React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { GridContainer } from '@pec/aion-ui-components/components/GridContainer';
import { Loading } from '@pec/aion-ui-components/components/Loading';
import { OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';
import { Tile } from '../components/Tile';
import { useFeature } from 'flagged';
import { usePermission } from '../hooks/usePermission';
import { useTypedSelector } from '../combineReducers';

export const NgqeUsCohortGuard: React.FC = ({ children }) => {
  const { organization, isFetching } = useTypedSelector(state => state.organization);
  const isFeatureEnabled = useFeature('NgqeUsCohort');
  const isChasContractor = organization?.features.includes(OrganizationFeature.ChasOrganizationFields);
  const { hasGlobalQuestionnaireAdminPermission } = usePermission();

  if (isFetching) return <Loading />;

  if (isFeatureEnabled && !isChasContractor && !hasGlobalQuestionnaireAdminPermission) {
    return (
      <Box padding={3}>
        <GridContainer style={{ display: 'flex', minHeight: '90%' }}>
          <Grid item xs={12}>
            <Tile primaryText={'Questionnaire'}>
              <GridContainer>
                <Typography variant="h6" color="error">
                  Your questionnaire is temporarily unavailable as we work on enhancing your questionnaire experience.
                  You will be notified once this upgrade is complete.
                </Typography>
              </GridContainer>
            </Tile>
          </Grid>
        </GridContainer>
      </Box>
    );
  }

  return <>{children}</>;
};
